export const ENV = {
  API_HOST: process.env.REACT_APP_API_HOST,
};

export const ROUTERS = {
  HOME: '/',
  REGISTER: '/register',
  LOGIN: '/login',
  CONTACTS: '/contacts',
  ERROR_404: '/error404'
}